


























import { defineComponent } from "@vue/composition-api";
import { StoryTip } from "@scrile/api-provider/dist/api/StoriesProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { formatMoneyString, getMainCurrencyCode } from "@/lib/moneyHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "StoryStatisticTipItem",
  components: { BaseIconButton, BaseAvatar, BaseIcon },
  props: {
    item: { type: Object as () => StoryTip, required: true },
  },
  setup(_, { root, emit }) {
    const { authUserStrict } = useAuthUser();
    const goToMessage = (userId: string) => {
      emit("close");
      root.$router.push({ name: "messages", params: { userId } });
    };
    const formatTips = (amount: number) => formatMoneyString(amount, { currencyCode: getMainCurrencyCode() });
    return { authUserStrict, goToMessage, formatTips, resolveUserName };
  },
});
